import { render } from "./cardWizard.vue?vue&type=template&id=160ff0af"
import script from "./cardWizard.vue?vue&type=script&lang=js"
export * from "./cardWizard.vue?vue&type=script&lang=js"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__